import React from 'react';
import PropTypes from 'prop-types';
import { formatCurrency, formatDate, abbreviateFrequency } from '../../../utils/formatters';
import { REQUIREMENT_DISPLAY_KINDS } from '../../../utils/requirementCalculations';
import { filterActiveAllocations } from './AllocationQuickList';

/**
 * Minimal bill list for quick reference (no edit or actions).
 */
const BillQuickList = ({ bills, fortnightStart, fortnightEnd }) => {
  const active = filterActiveAllocations(bills, fortnightStart, fortnightEnd);

  if (!active.length) {
    return <p className="text-muted small mb-0">No active bills this fortnight.</p>;
  }

  return (
    <ul className="requirements-quick-list mb-0">
      {active.map((req) => {
        const kindLabel =
          REQUIREMENT_DISPLAY_KINDS[req.display_kind] || req.display_kind || 'Bill';
        const freqAbbrev = abbreviateFrequency(req.frequency);
        return (
          <li key={req.id} className="requirements-quick-list-item">
            <div className="requirements-quick-list-line1">
              <span className="requirements-quick-list-name">{req.name}</span>
              <span className="requirements-quick-list-amount-freq text-muted">
                {formatCurrency(req.amount)}/{freqAbbrev}
              </span>
            </div>
            <div className="requirements-quick-list-line2 text-muted">
              <span className="requirements-quick-list-kind">{kindLabel}</span>
              <span className="requirements-quick-list-due">
                {req.next_unpaid_date ? (
                  <>Next Due: {formatDate(req.next_unpaid_date)}</>
                ) : (
                  <>No due date</>
                )}
              </span>
            </div>
          </li>
        );
      })}
    </ul>
  );
};

BillQuickList.propTypes = {
  bills: PropTypes.arrayOf(PropTypes.object).isRequired,
  fortnightStart: PropTypes.instanceOf(Date),
  fortnightEnd: PropTypes.instanceOf(Date),
};

export default BillQuickList;
